module.exports = __webpack_public_path__ + "img/aur-logo.4320f0ed.svg";